import React from 'react';
import styled from 'styled-components';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { getBoundedScore, getScoreColor } from 'ff/debrief/utils';
import Skeleton from '@mui/material/Skeleton';

interface Props {
    score?: number;
}

const SegmentScore = React.forwardRef<HTMLDivElement, Props>(
    function SegmentScore(props, ref) {
        const { score, ...rest } = props;
        const boundedScore = getBoundedScore(score);
        const scoreColor = getScoreColor(score);

        if (typeof boundedScore === 'number') {
            return (
                <CenteredBox ref={ref} sx={{ bgcolor: scoreColor }} {...rest}>
                    <ScoreText>{boundedScore}</ScoreText>
                </CenteredBox>
            );
        } else {
            return (
                <Skeleton
                    ref={ref}
                    variant="rounded"
                    height={20}
                    width={27}
                    {...rest}
                />
            );
        }
    }
);

export const NoScore = React.forwardRef<HTMLDivElement, Props>(
    function NoScore(props, ref) {
        const { ...rest } = props;
        return (
            <CenteredBox
                ref={ref}
                sx={{
                    bgcolor: '#e5e5e5',
                }}
                {...rest}
            >
                <ScoreText style={{ color: '#424853' }}>--</ScoreText>
            </CenteredBox>
        );
    }
);

const CenteredBox = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 6px;
    border-radius: 4px;
    width: 27px;
    height: 20px;
`;

const ScoreText = styled(Typography)`
    color: #fff;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.12);
    font-size: 12px;
    line-height: 12px;
    letter-spacing: 0.5px;
    font-weight: 700;
`;

export default SegmentScore;
